import React, { useEffect, useState } from 'react'
import TempPlot from './temp-plot'
import axios from 'axios'

const Temperatures = () => {
    const [tempData, setTempData] = useState([])

    useEffect(() => {
        // http://192.168.2.35:8123/api/history/period
        loadData()

        const interval = setInterval(() => {
            loadData()
        }, 1000 * 60 * 5) //every 5 minutes
        return () => clearInterval(interval)
    }, [])

    const loadData = () => {
        return axios
            .get('http://192.168.2.35:8123/api/history/period?filter_entity_id=sensor.termostat_venku_teplota,sensor.termostat_obyvak_base,sensor.termostat_vnitrek_teplota_3,sensor.shelly_trv_dole_koupelna,sensor.shelly_trv_dole_satna,sensor.shelly_trv_veranda,sensor.shelly_trv_vrch_koupelna,sensor.shelly_trv_vrch_loznice,sensor.shelly_trv_vrch_pracovna', {
                headers: {
                    Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJkMWEyZGNiZDI5ZmE0YWU3YmFmMDgxNjMxMDhjNmExNiIsImlhdCI6MTY4OTI4NjQ3NywiZXhwIjoyMDA0NjQ2NDc3fQ.DkrIPa0g6jhsyRor4ZRNJKc883vIFMWdbJFS7B8SsV4',
                },
            })
            .then(response => setTempData(response.data))
    }

    return (
        <div className="p-3 d-flex flex-row flex-wrap">
            <TempPlot
                plotValues={tempData}
                entityName="sensor.termostat_venku_teplota"
                title="Venku"
            />
            <TempPlot
                plotValues={tempData}
                entityName="sensor.termostat_obyvak_base"
                title="Obývák"
            />
            <TempPlot
                plotValues={tempData}
                entityName="sensor.termostat_vnitrek_teplota_3"
                title="Pracovna dole"
            />
            <TempPlot
                plotValues={tempData}
                entityName="sensor.shelly_trv_dole_koupelna"
                title="Dole koupelna"
            />
            <TempPlot
                plotValues={tempData}
                entityName="sensor.shelly_trv_dole_satna"
                title="Dole šatna"
            />
            <TempPlot
                plotValues={tempData}
                entityName="sensor.shelly_trv_veranda"
                title="Dole veranda"
            />
            <TempPlot
                plotValues={tempData}
                entityName="sensor.shelly_trv_vrch_koupelna"
                title="Vrch koupelna"
            />
            <TempPlot
                plotValues={tempData}
                entityName="sensor.shelly_trv_vrch_loznice"
                title="Vrch ložnice"
            />
            <TempPlot
                plotValues={tempData}
                entityName="sensor.shelly_trv_vrch_pracovna"
                title="Vrch pracovna"
            />
        </div>
    )
}

export default Temperatures
